import React from 'react';
import SellFromSweepTile from '../../components/LandingPage/SellFromSweepTile/SellFromSweepTile';
import config from '../../config/config';
import { ProductTypes } from '../../settings/settings';
import Add from '../../components/Shared/Icons/Add.image';
import TRP from '../../components/Shared/TRP/TRP';
import Calendar from '../../components/Shared/Icons/Calendar.image';
import Exchange from '../../components/Shared/Icons/Exchange.image';
import Minus from '../../components/Shared/Icons/Minus.image';
import Trade from '../../components/Shared/Icons/Trade.image';
import Transfer from '../../components/Shared/Icons/Transfer.image';
import TransferAccount from '../../components/Shared/Icons/TransferAccount.image';
import { appendBasePath } from '../../utils/nav.utils';
import styles from '../../components/Shared/APPText/APPText.module.scss';

export const moreTransactions = [
  {
    description: 'Start a new account and fund it electronically or by check.',
    link: `${config.url}/personal-investing/tools/fund-research/account-finder`,
    title: 'Open New Account',
  },
  {
    description:
      'Roll over assets from an eligible employer-sponsored retirement account into a personal investing retirement account.',
    link: `${config.url}/personal-investing/tools/nasu/mutual-fund/retirement/rollover`,
    title: 'Rollover',
  },
  {
    description: 'Convert a Traditional IRA or Rollover IRA to a Roth IRA.',
    link: `${config.url}/usis/transactions/roth-conversion`,
    title: 'Roth Conversion',
  },
  {
    description: 'Transfer accounts held at other financial institutions.',
    link: `${config.url}/personal-investing/account-finder/transfers.html`,
    title: 'Transfer',
  },
];
export const qcdLanding = {
  description:
    'Use your IRA to make a nontaxable donation to a qualifying charity.',
  link: `${config.url}/usis/transactions/qcd/landing`,
  title: 'Qualified Charitable Distribution',
};

export const getMoreTransactions529 = (planType) => {
  if (!planType) {
    return [
      {
        description: 'Start a new plan and fund it electronically or by check.',
        link: `${config.url}/usis/nasu/account-finder`,
        title: 'Open New Account',
      },
    ];
  }
  let openLink;
  let rolloverLink;
  if (planType === ProductTypes.ALASKA529) {
    openLink = `${config.url}/usis/nasu/start/college-savings/alaska`;
    rolloverLink =
      'https://www.alaska529plan.com/content/dam/alaska529/forms/Rollover_Form.pdf';
  } else if (planType === ProductTypes.MARYLAND529) {
    openLink = `${config.url}/usis/nasu/start/college-savings/maryland`;
    rolloverLink = 'https://maryland529.com/Portals/0/Forms/Rollover_Form.pdf';
  } else {
    openLink = `${config.url}/usis/nasu/start/college-savings/national`;
    rolloverLink =
      'https://individual.troweprice.com/public/Retail/xStaticFiles/FormsAndLiterature/TransferAssets/trpRolloversOnlyForm.pdf?src=AccountFinder';
  }
  return [
    {
      description: 'Start a new plan and fund it electronically or by check.',
      link: openLink,
      title: 'Open New Account',
    },
    {
      description: 'Roll over balances from another plan.',
      link: rolloverLink,
      title: 'Rollover',
    },
  ];
};

const transactionLandingPageContent = {
  [ProductTypes.RAS + ProductTypes.ACTIVEPLUS]: [
    {
      description: 'Add money to your existing account(s)',
      icon: <Add />,
      link: `${config.url}/usis/transactions/advisory/add`,
      title: 'Add',
    },
    {
      description:
        'Withdraw from investments and have the proceeds sent to you.',
      icon: <Minus />,
      link: `${config.url}/usis/transactions/advisory/withdraw`,
      title: 'Withdraw',
    },
    {
      description:
        'Exchange assets between eligible investments. Retirement Advisory Service account(s) are not eligible.',
      icon: <Exchange />,
      link: `${config.url}/usis/transactions/exchange`,
      title: 'Exchange',
    },
    {
      description: (
        <span>
          Transfer any existing <TRP /> accounts to your managed portfolio.
        </span>
      ),
      icon: <TransferAccount />,
      link: `${config.url}/usis/advice/checkout/transfer`,
      title: 'Transfer Accounts',
    },
    {
      description: 'Set up and manage recurring transactions.',
      icon: <Calendar />,
      link: `${config.url}${appendBasePath('/automatic')}`,
      title: 'Automatic Transactions',
    },
  ],
  [ProductTypes.RAS]: [
    {
      description: 'Add money to your existing account(s)',
      icon: <Add />,
      link: `${config.url}/usis/transactions/advisory/add`,
      title: 'Add',
    },
    {
      description:
        'Withdraw from your Retirement Advisory Service account(s) and have the proceeds sent to you.',
      icon: <Minus />,
      link: `${config.url}/usis/transactions/advisory/withdraw`,
      title: 'Withdraw',
    },
    {
      description: 'Set up and manage recurring transactions.',
      icon: <Calendar />,
      link: `${config.url}${appendBasePath('/automatic')}`,
      title: 'Automatic Transactions',
    },
    {
      description: (
        <span>
          Transfer any existing <TRP /> accounts to your managed portfolio.
        </span>
      ),
      icon: <TransferAccount />,
      link: `${config.url}/usis/advice/checkout/transfer`,
      title: 'Transfer Accounts',
    },
  ],
  [ProductTypes.ACTIVEPLUS]: [
    {
      description: 'Add money to your existing account(s)',
      icon: <Add />,
      link: `${config.url}/usis/transactions/advisory/add`,
      title: 'Add',
    },
    {
      description: (
        <div>
          Withdraw from your ActivePlus Portfolios
          <sup className={styles.sup}>®</sup> account(s) and have the proceeds
          sent to you.
        </div>
      ),
      icon: <Minus />,
      link: `${config.url}/usis/transactions/advisory/withdraw`,
      title: 'Withdraw',
    },
    {
      description: 'Exchange assets between eligible investments.',
      icon: <Exchange />,
      link: `${config.url}/usis/transactions/exchange`,
      title: 'Exchange',
    },
    {
      description: (
        <div>
          Transfer or rollover money from another institution to an existing
          ActivePlus Portfolios<sup className={styles.sup}>®</sup> account(s).
        </div>
      ),
      icon: <Transfer />,
      link: `${config.url}/usis/activeplus-portfolios/secure/subsequent/funding?targetNavigation=fundingOption`,
      title: 'Roll Over & Transfer',
    },
    {
      description: 'Set up and manage recurring transactions.',
      icon: <Calendar />,
      link: `${config.url}${appendBasePath('/automatic')}`,
      title: 'Automatic Transactions',
    },
  ],
  [ProductTypes.MUTUALFUND]: [
    {
      description: 'Add money to a new or existing investment from your bank.',
      icon: <Add />,
      link: `${config.url}/usis/transactions/buy`,
      title: 'Buy',
    },
    {
      description:
        'Withdraw from your investments and have the proceeds sent to you.',
      icon: <Minus />,
      link: `${config.url}/usis/transactions/sell`,
      title: 'Sell',
    },
    {
      description: 'Exchange assets between eligible investments.',
      icon: <Exchange />,
      link: `${config.url}/usis/transactions/exchange`,
      title: 'Exchange',
    },
    {
      description: 'Set up and manage recurring transactions.',
      icon: <Calendar />,
      link: `${config.url}/usis/transactions/automatic`,
      title: 'Automatic Transactions',
    },
  ],
  [ProductTypes.BROKERAGE]: [
    {
      description: 'Trade your shares of stocks or exchange traded funds.',
      icon: <Trade />,
      link: `${config.url}/usis/my-accounts/brokerage?selectedAccountId=undefined&target=TRADING`,
      title: 'Trade Stocks & ETFs',
      newPage: false,
    },
    {
      description:
        'Buy, sell, or exchange shares among hundreds of no-load funds.',
      icon: <Trade />,
      link: `${config.url}/usis/my-accounts/brokerage?selectedAccountId=undefined&target=MF_TRADING`,
      title: 'Trade Mutual Funds ',
      newPage: false,
    },
    {
      description:
        'Buy or sell options on a broad range of securities and financial investments.',
      icon: <Trade />,
      link: `${config.url}/usis/my-accounts/brokerage?selectedAccountId=undefined&target=TRADING`,
      title: 'Trade Options¹',
      newPage: false,
    },
    {
      component: SellFromSweepTile,
      description:
        'Sell shares from your brokerage sweep account and have the proceeds sent to you.',
      icon: <Minus />,
      title: 'Sell from Sweep Account',
    },
  ],
  COLLEGE: [
    {
      description: 'Add money to an existing account.',
      icon: <Add />,
      link: `${config.url}/usis/transactions/college/contribute`,
      title: 'Contribute',
    },
    {
      description: 'Withdraw from an existing account.',
      icon: <Minus />,
      link: `${config.url}/usis/transactions/college/distribute`,
      title: 'Distribute',
    },
    {
      description:
        'Move assets between investment options for the same beneficiary.',
      icon: <Exchange />,
      link: `${config.url}/usis/transactions/college/exchange`,
      title: 'Exchange',
    },
    {
      description: 'Set-up and manage recurring contributions.',
      icon: <Calendar />,
      link: `${config.url}/usis/transactions/automatic`,
      title: 'Automatic Monthly Contributions',
    },
  ],
};

export const rmdTile = {
  description: 'Determine and manage your RMDs.',
  icon: <Calendar />,
  link: `${config.url}/usis/rmd-tool/`,
  title: 'Required Minimum Distributions (RMD)',
};

export const rmdTileAPP = {
  ...rmdTile,
  description: (
    <div>
      Determine and manage your RMDs in your ActivePlus Portfolios
      <sup className={styles.sup}>®</sup> account(s).
    </div>
  ),
};

export default transactionLandingPageContent;
